/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2297
 */

"use strict"

var r = require(/* 180 */"../../../../180")
var i = require(/* 204 */"../../../../204")
var o = require(/* 283 */"../../../../../../1058/1393/1143/283/index")
var a = require(/* 284 */"../../../../../../1058/1393/1143/284/index")
var s = require(/* 853 */"../1140/853")
var c = require(/* 854 */"../854")
module.exports = function (e) {
  o(n, e)
  var t = a(n)
  function n(e, i, o, a, s) {
    var u
    r(this, n);
    (u = t.call(this)).tokens = e
    u.index = c.getLastIndex(e, o, s)
    u.indexEnd = c.getFirstIndex(e, o, a)
    return u
  }
  i(n, [
    {
      key: "moveNext",
      value: function () {
        return this.index >= this.indexEnd && (this.current = this.tokens[this.index], this.index -= 1, true)
      }
    }, {
      key: "getOneToken",
      value: function () {
        return this.index >= this.indexEnd ? this.tokens[this.index] : null
      }
    }
  ])
  return n
}(s)
